import * as React from 'react'
import DefaultKeycloakErrorPage from './DefaultKeycloakErrorPage'
import AccessDenied from './AccessDenied'
import InvalidRedirectUrl from './InvalidRedirectUrl'
import Error from '../components/Error'
import { ForbiddenAccessIcon } from '../icons'
import { invalidRedirectUri } from '../util/kcMessage'
import type { Customization } from '../types/Customization'

type ErrorPageProps = {
  error: string
  kcMessage: string
  customization?: Customization
}

const InternalErrorText = (
  <p>
    Internal error, please try logging in again.
    <br />
    If you continue to have issues, please review the Help Page and contact us for assistance.
  </p>
)

type KcMessageErrorPageProps = {
  kcMessage: string
  customization?: Customization
}

const KcMessageErrorPage = ({ kcMessage, customization }: KcMessageErrorPageProps): JSX.Element => {
  switch (kcMessage) {
    case invalidRedirectUri:
      return <InvalidRedirectUrl customization={customization} />
    default:
      return <Error icon={<ForbiddenAccessIcon />} title="Error" text={InternalErrorText} />
  }
}

const KeycloakErrorPage = ({ error, kcMessage, customization }: ErrorPageProps): JSX.Element => {
  console.error({ errorCode: error, keycloakMessage: kcMessage })
  switch (error) {
    case 'K00':
      return KcMessageErrorPage({ kcMessage, customization })
    case 'K02':
      return <AccessDenied customization={customization} />
    default:
      return <DefaultKeycloakErrorPage customization={customization} />
  }
}

export default KeycloakErrorPage
